import styled from "styled-components";

export const StatsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 3.3rem 2rem;
  gap: 2.5rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 1rem;
  }

  .total-cards {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (min-width: ${({theme}) => theme.screen.smallScreen}) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .product-stat-wrapper {
    width: 100%;
    padding: 1rem;
    background-color: ${({ theme }) => theme.bg.prim_500};
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    border-radius: 0.25rem;

    .delivery-title {
      font-size: 1.2rem;
      color: ${({ theme }) => theme.text.prim_200};
    }
  }

  .product-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    width: 100%;

    @media (max-width: ${({ theme }) => theme.screen.mobile}) {
      grid-template-columns: repeat(1, 1fr);
      gap: 1rem;
    }

    @media (max-width: 768px) and (min-width: 480px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
    }
  }

  .top-card {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background-color: ${({ theme }) => theme.bg.prim_500};
    box-shadow: ${({ theme }) => theme.shadow.shad_100};
    border-radius: 0.625rem;
  }
  .dash-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: ${({ theme }) => theme.text.prim_100};
  }

  .underline {
    border-bottom: 1px solid ${({ theme }) => theme.border.input};
    padding-bottom: 0.3rem;
    width: 12rem;
  }

  .dash-text {
    font-size: 0.8rem;
    font-weight: 500;
    color: ${({ theme }) => theme.text.prim_100};
  }

  .title {
    width: 100%;
    justify-content: space-between;
  }

  .top-row {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: stretch;
    gap: 1rem;

    @media screen and (max-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(1, 1fr);
    }

    .client-chart {
      width: 100%;
      background-color: ${({ theme }) => theme.bg.prim_500};
      padding: 1rem;
      border-radius: 0.25rem;
    }

    .distributors {
      width: 100%;
      flex-direction: column;
      display: flex;
      gap: 1rem;
      padding: 1rem;

      .distri-table {
        gap: 1rem;
      }

      .distri-tb-row {
        width: 100%;
        justify-content: space-between;
        align-items: flex-start;
      }

      .table-header {
        font-size: 1rem;
        color: ${({ theme }) => theme.text.prim_100};
        font-weight: 600;
      }

      .table-text {
        font-size: 0.875rem;
        color: ${({ theme }) => theme.text.prim_100};
        font-weight: 400;
      }

      .left {
        width: 35%;
      }

      .right {
        width: 60%;
      }

      .table-header {
      }
    }
  }

  .lower-row {
    width: 100%;
    align-items: stretch;
    gap: 1rem;

    @media (max-width: ${({ theme }) => theme.screen.tablet}) {
      flex-direction: column;
      gap: 2rem;
    }

    .line-chart {
      flex: 3;
    }

    .notifications {
      flex: 2;
      justify-content: flex-start;
      background-color: ${({ theme }) => theme.bg.prim_500};
      padding: 1rem;

      .title {
        width: 100%;
        justify-content: space-between;

        h3 {
          color: #7661e2;
          font-weight: 500;
          font-size: 0.875rem;
        }
      }

      .notifications-wrapper {
        width: 100%;
        padding-top: 1rem;
        height: 100%;
        gap: 0.5rem;

        .no-notif {
          font-weight: 500;
          color: ${({ theme }) => theme.text.prim_200};
        }
      }
    }
  }
`;
